export type TsearchCategoryName = {
  category: string;
  subCategory: string;
  categoryType?: 'M' | 'F';
  subCategoryType?: 'M' | 'F';
  subCategoryEnPart?: string;
  subCategoryAlertInfo?: {
    slug: string;
    name: string;
    is_pro_allowed: string;
    is_allowed: string;
  };
};

const searchCategoryName = (
  search: TCategorySelection,
  groups: Array<TCategory>
): TsearchCategoryName => {
  const defaultReturn = {
    category: '',
    subCategory: '',
  };

  if (!search || !search?.category) {
    return defaultReturn;
  }

  const category = groups?.find((el: TCategory) => el.slug === search?.category);

  if (!category) {
    return defaultReturn;
  }
  const fakeCategory = { ...category, parts: Object.values(category?.parts) };
  const subCategory = Object.values(fakeCategory?.parts)
    .reduce((acc, c) => [...acc, ...c], [])
    .find((el: TPart) => el.slug === search.subCategory);

  return {
    category: category?.name || '',
    subCategory: subCategory?.name || '',
    categoryType: category?.gender || 'M',
    subCategoryType: subCategory?.gender || 'M',
    subCategoryEnPart: subCategory?.part_en || '',
    subCategoryAlertInfo: subCategory
      ? {
          slug: subCategory?.slug,
          name: subCategory?.name,
          is_pro_allowed: subCategory['is_pro_allowed'],
          is_allowed: subCategory['is_allowed'],
        }
      : {},
  };
};

export default searchCategoryName;
